<template>
  <div>
    <custom-collapse id="rubric-questions-collapse" class="px-4">
      <custom-collapse-item
        v-for="(item, key) in value"
        :id="`question-collapse-item-${key + 1}`"
        :key="`question-collapse-item-${key + 1}`"
        :ref="`question-collapse-item-${key + 1}`"
        :auto-expand-collapse-enabled="false"
        :button-icon="value.length > 1 ? 'far fa-times-circle color-red' : ''"
        class="my-3 collapse-item question bg-white"
        :class="{ 'rounded invalid': item.valid === false }"
        :component-key="key"
        :disabled="isReadOnly"
        :expanded="item.expanded"
        expanded-icon="fas fa-plus-circle custom-reorganize-btn"
        icon-class-when-button-disabled="fas fa-grip-vertical flex-fill d-flex justify-content-end align-items-center"
        :keep-btn-visible="false"
        parent-id="rubric-questions-collapse"
        read-only-icon="fas fa-plus-circle color-gray-2"
        :title="getQuestionTitle(item, key)"
        @actionButtonClick="quit(key)"
        @expandButtonClick="expand(item, key)"
      >
        <validation-observer :ref="`question-${key}`">
          <div class="mb-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="item.name"
                custom-error-msg="El subtítulo es requerido."
                :error="errors[0]"
                label="Subtítulo de Sección:"
                placeholder="Subtítulo de Sección"
              />
            </validation-provider>
          </div>
          <div class="my-3">
            <custom-text-area
              v-model="item.notes"
              :count-classes="['d-block', 'small-counter']"
              label="Notas:"
              :maxlength="3000"
              placeholder="Escribe una Nota"
              show-char-count
            />
          </div>
          <div class="my-3">
            <div class="data-title">
              Valor de Expectativas
            </div>
            <div class="row">
              <div
                v-for="answer in item.answers"
                :key="answer.answerId"
                class="col-12 col-md"
              >
                <div class="card expectative">
                  <div
                    class="card-header"
                    :style="{
                      borderBottom: `4px solid ${answer.color ||
                        'red'} !important`,
                    }"
                  >
                    {{ answer.text | empty }}
                  </div>
                  <div class="card-body">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="min_value:0|required"
                    >
                      <custom-input
                        v-model.number="answer.value"
                        custom-error-msg="El campo es requerido"
                        :error="errors[0]"
                        :min="0"
                        type="number"
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </custom-collapse-item>
    </custom-collapse>
    <div class="d-flex justify-content-end pr-2">
      <action-button
        i="fas fa-file-plus"
        text="Añadir Sub-Sección"
        variant="success"
        @click="add"
      />
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomTextArea from 'CustomTextArea';
import CustomCollapse from '@/components/common/CustomCollapse.vue';
import CustomCollapseItem from '@/components/common/CustomCollapseItem.vue';
import ActionButton from 'ActionButton';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'Questions',
  components: {
    CustomInput,
    CustomTextArea,
    CustomCollapse,
    CustomCollapseItem,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    answers: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    getQuestionTitle() {
      return ({ name }, key) => name ?? `Sub-Sección ${key + 1}`;
    },
  },
  mounted() {
    if (this.value.length === 0) this.add();
  },
  methods: {
    async add() {
      const valid = await this.validate();
      if (!valid) {
        this.ShowToast(
          'Alerta',
          'Es necesario documentar las subsecciones agregadas.',
          'error'
        );
        return;
      }
      const answers = this.answers.map((x) => ({
        answerId: x.id,
        text: x.text,
        color: x.color,
        value: null,
      }));
      const item = {
        name: null,
        notes: null,
        answers,
        valid: true,
        expanded: false,
      };
      this.value.push(item);
      this.expand(item, this.value.length - 1);
      this.$emit('add', item);
    },
    expand(item, key) {
      this.value
        .filter((x, i) => i !== key)
        .forEach((x) => (x.expanded = false));
      setTimeout(() => (item.expanded = !item.expanded), 100);
    },
    async quit(key) {
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover la <strong>Sub-Sección ${key +
          1}</strong>, se eliminarán los datos suministrados hasta ahora?`,
        'Si',
        'No'
      );

      if (!confirmed) return;
      this.value.splice(key, 1);
    },
    async validate() {
      if (!this.value.length) return true;
      const forms = this.value.map((item, key) => {
        const validator = this.$refs[`question-${key}`][0];
        return validator.validate().then((val) => (item.valid = val));
      });
      await Promise.all(forms);
      if (this.value.length > 1) this.$emit('validate', this.value);
      return this.value.every((x) => x.valid);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/brand_variables.scss';
.bg-inherit {
  background-color: inherit;
}
.btn-toggle {
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
  color: white;
  font-weight: 600;
  font-family: fantasy;
  border: 2px solid white;
}

.dot-pei {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  display: inline-block;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  text-align: center;
}
.dot-pei .fas {
  font-size: 17px;
}

.icon-view__extended ::v-deep {
  .dot {
    em {
      margin-top: -2px !important;
      margin-left: 2px !important;
    }
  }
}

.collapse-item ::v-deep .shadow2 {
  background-color: white !important;
}

.collapse-item ::v-deep > .card-header {
  background-color: white !important;
}
.collapse-item.question.invalid {
  border: 1px solid #ff0018 !important;
}

.card.expectative .card-body {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
</style>
